import { AccountFeatures, AppContext, Features } from '@lightspeed-invoicing/core-client/frontend/index'
import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import GlobalHelper from "../../common/GlobalHelper.jsx"
import Icon from "../../common/icon/icon.component.jsx"
import LoadingSpinner from "../../common/spinner/loading.component.jsx"
import { getOptionValueWithOptionKey } from '../../state/default-option/DefaultOption'
import DefaultOptionService from '../../state/default-option/DefaultOptionService'
import { isError } from '../../state/helpers/Error'
import { SupportedSettings } from './Settings.jsx'

class AccountDetailsSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            accountDefaultCurrency: '',
            accountDefaultLanguage: '',
            accountTimeZone: '',
            documentSubDomain: '',
            quotePrefix: '',
            quoteStartFrom: '',
            invoicePrefix: '',
            invoiceStartFrom: '',
            orderPrefix: '',
            orderStartFrom: '',
            defaultQuoteDepositRatio: 0,
            defaultOrderDepositRatio: 0,
            showShortDescriptionInListing: false,
            showSKUInPricingTable: false,
            autoApplyAvailableCreditMemo: false,
            hideBranding: false,
            additionalCurrencies: [],
            additionalLanguages: [],
            testMode: false,
            account: null,
            pageSize: 'letter',
            numberOfDaysBeforeQuoteExpiration: 0,
            taxNumber: '',
        };
    }

    componentDidMount() {
        AppContext.getApiClient().get('/accounts/account-details').then((result) => {
            this.setState({
                accountDefaultCurrency: result.attributes.currency,
                accountDefaultLanguage: result.attributes.defaultLanguage,
                accountTimeZone: result.attributes.timeZone,
                additionalCurrencies: result.attributes.additionalCurrencies,
                additionalLanguages: result.attributes.additionalLanguages,
                testMode: result.attributes.testMode,
                account: result,
                hideBranding: result.attributes.hideBranding,
                pageSize: result.attributes.pageSize,
                numberOfDaysBeforeQuoteExpiration: result.attributes.numberOfDaysBeforeQuoteExpiration,
                taxNumber: result.attributes.taxNumber,
            })
        })

        DefaultOptionService.RetrieveDefaultProposalOptions().then(res => {
            if (!isError(res)) {
                this.setState({
                    quotePrefix: getOptionValueWithOptionKey(res, 'quote-identifier-prefix', 'QUO'),
                    quoteStartFrom: getOptionValueWithOptionKey(res, 'quote-identifier-start-from', '1'),
                    documentSubDomain: getOptionValueWithOptionKey(res, 'quote-sub-domain', ''),
                    defaultQuoteDepositRatio: getOptionValueWithOptionKey(res, 'default-quote-deposit', 0),
                    invoicePrefix: getOptionValueWithOptionKey(res, 'invoice-identifier-prefix', 'INV'),
                    invoiceStartFrom: getOptionValueWithOptionKey(res, 'invoice-identifier-start-from', '1'),
                    orderPrefix: getOptionValueWithOptionKey(res, 'order-identifier-prefix', 'ORD'),
                    orderStartFrom: getOptionValueWithOptionKey(res, 'order-identifier-start-from', '1'),
                    showShortDescriptionInListing: getOptionValueWithOptionKey(res, 'show-short-description-in-listing', false),
                    showSKUInPricingTable: getOptionValueWithOptionKey(res, SupportedSettings.ShowSKUInPricingTable, false),
                    autoApplyAvailableCreditMemo: getOptionValueWithOptionKey(res, 'auto-apply-available-credit-memo', false),
                    defaultOrderDepositRatio: getOptionValueWithOptionKey(res, 'default-order-deposit', 0),
                })
            }
        })
    }

    isInvoiceEnabled() {
        return AppContext.getAccount().isFeatureEnabled(Features.Invoice)
    }

    isOrderEnabled() {
        return AppContext.getAccount().isFeatureEnabled(AccountFeatures.FeatureOrder)
    }

    render() {
        if (!this.state.account) {
            return <LoadingSpinner />
        }
        const supportedFeatures = []

        if (AppContext.getUserLoggedIn().attributes.superUser) {
            supportedFeatures.push({
                key: Features.WorkOrder,
                label: <FormattedMessage
                    id="settings.account.feature.work_order_label"
                    defaultMessage="Work order module"
                />
            })
        }

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="m-0 custom-lead">
                                    <FormattedMessage
                                        id='settings.account'
                                        defaultMessage='Account settings'
                                    />
                                </h2>
                            </div>
                            <div className="col-4 justify-content-end action-bar text-right">
                                <Link to="/settings/editAccountDetails" className="btn btn-primary">
                                    <Icon value={"edit"} />
                                    <FormattedMessage
                                        id="settings.edit_account_btn"
                                        defaultMessage="Edit Account"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="row ui-has-modules">
                        <div className="col-12 ui-module">
                            <dl className="dl-horizontal">
                                <dt>
                                    <FormattedMessage
                                        id="settings.account.test_mode_label"
                                        defaultMessage="Test mode"
                                    />
                                </dt>
                                <dd>{this.state.testMode ? <span className="text-success">
                                    <Icon value={"check-circle"} />
                                </span> : <span className="text-secondary">
                                    <Icon value={"times-circle"} />
                                </span>}</dd>

                                <dt>
                                    <FormattedMessage
                                        id="settings.account.currency_label"
                                        defaultMessage="Currency"
                                    />
                                </dt>
                                <dd>{this.state.accountDefaultCurrency}</dd>

                                {this.state.additionalCurrencies.length > 0 ? <dt>
                                    <FormattedMessage
                                        id="settings.account.additional_currency_label"
                                        defaultMessage="Additional currencies"
                                    />
                                </dt> : null}
                                {this.state.additionalCurrencies.length > 0 ?
                                    <dd>{this.state.additionalCurrencies.join(', ')}</dd> : null}

                                <dt>
                                    <FormattedMessage
                                        id="settings.account.language_label"
                                        defaultMessage="Language"
                                    />
                                </dt>
                                <dd>
                                    {this.props.intl.formatMessage(GlobalHelper.getLanguageMessage(
                                        this.state.accountDefaultLanguage ?
                                            this.state.accountDefaultLanguage.substring(0, 2) :
                                            "en"))}
                                </dd>

                                {this.state.additionalLanguages.length > 0 ? <dt>
                                    <FormattedMessage
                                        id="settings.account.additional_languages_label"
                                        defaultMessage="Additional languages"
                                    />
                                </dt> : null}
                                {this.state.additionalLanguages.length > 0 ? <dd>
                                    {this.state.additionalLanguages.map(language => {
                                        return <span className="mr-2">
                                            {this.props.intl.formatMessage(GlobalHelper.getLanguageMessage(language))}
                                        </span>
                                    })}
                                </dd> : null}

                                <dt>
                                    <FormattedMessage
                                        id="settings.account.time_zone_label"
                                        defaultMessage="Time zone"
                                    />
                                </dt>
                                <dd>{this.state.accountTimeZone}</dd>
                                {this.state.taxNumber ?
                                    <span>
                                        <dt>
                                            <FormattedMessage
                                                id="settings.account.tax_number_label"
                                                defaultMessage="Tax number"
                                            />
                                        </dt>
                                        <dd>{this.state.taxNumber}</dd>
                                    </span> : ''}
                                <dt>
                                    <FormattedMessage
                                        id="settings.account.page_size_label"
                                        defaultMessage="Paper size"
                                    />
                                </dt>
                                <dd>{this.state.pageSize}</dd>

                                {this.state.documentSubDomain &&
                                    <span>
                                        <dt>
                                            <FormattedMessage
                                                id="settings.account.form.edit.document_sub_domain_label"
                                                defaultMessage="Document sub domain"
                                            />
                                        </dt>
                                        <dd>{this.state.documentSubDomain}</dd>
                                    </span>
                                }

                                <dt>
                                    <FormattedMessage
                                        id="settings.account.form.edit.quote_prefix_label"
                                        defaultMessage="Quote prefix"
                                    />
                                </dt>
                                <dd>{this.state.quotePrefix}</dd>

                                <dt>
                                    <FormattedMessage
                                        id="settings.account.form.edit.quote_start_from_label"
                                        defaultMessage="Initial quote number"
                                    />
                                </dt>
                                <dd>{this.state.quoteStartFrom}</dd>

                                {this.isInvoiceEnabled() ? <dt>
                                    <FormattedMessage
                                        id="settings.account.form.edit.invoice_prefix_label"
                                        defaultMessage="Invoice number prefix"
                                    />
                                </dt> : ''}
                                {this.isInvoiceEnabled() ? <dd>{this.state.invoicePrefix}</dd> : ''}

                                {this.isInvoiceEnabled() ? <dt>
                                    <FormattedMessage
                                        id="settings.account.form.edit.invoice_start_from_label"
                                        defaultMessage="Initial invoice number"
                                    />
                                </dt> : ''}
                                {this.isInvoiceEnabled() ? <dd>{this.state.invoiceStartFrom}</dd> : ''}

                                {this.isOrderEnabled() &&
                                    <span>
                                        <dt>
                                            <FormattedMessage
                                                id="settings.account.form.edit.order_prefix_label"
                                                defaultMessage="Order prefix"
                                            />
                                        </dt>
                                        <dd>{this.state.orderPrefix}</dd>
                                        <dt>
                                            <FormattedMessage
                                                id="settings.account.form.edit.order_start_from_label"
                                                defaultMessage="Initial order number"
                                            />
                                        </dt>
                                        <dd>{this.state.orderStartFrom}</dd>
                                    </span>
                                }

                                {
                                    !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() &&
                                    <>
                                        <dt>
                                            <FormattedMessage
                                                id="settings.account.form.edit.default_quote_deposit_label"
                                                defaultMessage="Default quote deposit"
                                            />
                                        </dt>
                                        <dd>
                                            <FormattedNumber
                                                maximumFractionDigits={2}
                                                value={this.state.defaultQuoteDepositRatio || 0}
                                                style={'percent'}
                                            />
                                        </dd>
                                        <dt>
                                            <FormattedMessage
                                                id="settings.account.form.edit.default_proposal_order_deposit_label"
                                                defaultMessage="Default order deposit"
                                            />
                                        </dt>
                                        <dd>
                                            <FormattedNumber
                                                maximumFractionDigits={2}
                                                value={this.state.defaultOrderDepositRatio || 0}
                                                style={'percent'}
                                            />
                                        </dd>
                                    </>
                                }

                                <dt>
                                    <FormattedMessage
                                        id="settings.account.form.edit.expiration_number_of_days_label"
                                        defaultMessage="Number of days before quote expiration"
                                    />
                                </dt>
                                <dd>{this.state.numberOfDaysBeforeQuoteExpiration}</dd>

                                <dt>
                                    <FormattedMessage
                                        id="settings.account.form.edit.show_short_description_in_listing_label"
                                        defaultMessage="Show product short description in listing"
                                    />
                                </dt>
                                <dd>{this.state.showShortDescriptionInListing ? <span className="text-success">
                                    <Icon value={"check-circle"} />
                                </span> : <span className="text-secondary">
                                    <Icon value={"times-circle"} />
                                </span>}
                                </dd>

                                <dt>
                                    <FormattedMessage
                                        id="settings.account.form.edit.show_sku_in_pricing_table_label"
                                        defaultMessage="Show product SKU on the pricing table edition view"
                                    />
                                </dt>
                                <dd>{this.state.showSKUInPricingTable ? <span className="text-success">
                                    <Icon value={"check-circle"} />
                                </span> : <span className="text-secondary">
                                    <Icon value={"times-circle"} />
                                </span>}
                                </dd>

                                <dt>
                                    <FormattedMessage
                                        id="settings.account.form.edit.auto_apply_credit_memo_on_new_invoice_label"
                                        defaultMessage="Auto apply available credit memo on new invoices"
                                    />
                                </dt>
                                <dd>{this.state.autoApplyAvailableCreditMemo ? <span className="text-success">
                                    <Icon value={"check-circle"} />
                                </span> : <span className="text-secondary">
                                    <Icon value={"times-circle"} />
                                </span>}
                                </dd>

                                {AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureBranding) ?
                                    <div>
                                        <dt>
                                            <FormattedMessage
                                                id="settings.account.form.edit.hide_branding"
                                                defaultMessage="Hide Branding"
                                            />
                                        </dt>

                                        <dd>
                                            {this.state.hideBranding ?
                                                <span className="text-success">
                                                    <Icon value={"check-circle"} />
                                                </span> : <span className="text-secondary">
                                                    <Icon value={"times-circle"} />
                                                </span>}
                                        </dd>
                                    </div> : ""
                                }
                                {supportedFeatures.map(f => {
                                    let enabled = <span className="text-secondary">
                                        <Icon value={"times-circle"} />
                                    </span>
                                    if (this.state.account.isFeatureEnabled(f.key)) {
                                        enabled = <span className="text-success">
                                            <Icon value={"check-circle"} />
                                        </span>
                                    }
                                    return <dt key={f.key}>
                                        {f.label} {enabled}
                                    </dt>
                                })}
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default injectIntl(AccountDetailsSection)


// WEBPACK FOOTER //
// ./src/settings/account/detailsSection.component.jsx